import React from 'react'
import styled from 'styled-components'

import ReviewsSVG from './assets/Reviews.svg'

export const Reviews = () => {
  return (
    <Root>
      <img src={ReviewsSVG} alt='Review' />
    </Root>
  )
}

const Root = styled.div`
  margin-top: 12px;
`
